import { render, staticRenderFns } from "./FormControlSelect.vue?vue&type=template&id=8a50d600&scoped=true"
import script from "./FormControlSelect.vue?vue&type=script&lang=js"
export * from "./FormControlSelect.vue?vue&type=script&lang=js"
import style0 from "./FormControlSelect.vue?vue&type=style&index=0&id=8a50d600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a50d600",
  null
  
)

export default component.exports